(() => {
  const FORM_SELECTOR = '[data-sb-home-search]';
  const READY_KEY = 'sbHomeSearchReady';
  const mobileViewport = window.matchMedia('(max-width: 749px)');

  function updatePlaceholder(input) {
    const placeholder = mobileViewport.matches
      ? input.dataset.mobilePlaceholder
      : input.dataset.desktopPlaceholder;
    if (placeholder) input.placeholder = placeholder;
  }

  // Reload sources when crossing the phone breakpoint.
  function reloadMotionVideos() {
    document.querySelectorAll('video.sb-home-hero__motion').forEach((video) => video.load());
  }

  // Keep the still first; start motion after page load.
  function startMotionVideos(root) {
    root.querySelectorAll('video.sb-home-hero__motion').forEach((video) => {
      if (video.dataset.sbHomeMotionStarted === 'true') return;
      video.dataset.sbHomeMotionStarted = 'true';
      video.autoplay = true;
      video.preload = 'auto';
      video.load();
      const playback = video.play();
      if (playback && playback.catch) playback.catch(() => {});
    });
  }

  function updatePlaceholders() {
    document.querySelectorAll(`${FORM_SELECTOR} input[name="q"]`).forEach(updatePlaceholder);
  }

  function addViewportChangeListener(callback) {
    if (mobileViewport.addEventListener) {
      mobileViewport.addEventListener('change', callback);
    } else {
      mobileViewport.addListener(callback);
    }
  }

  function hidePrompt(input, prompt) {
    prompt.hidden = true;
    input.removeAttribute('aria-invalid');
  }

  function showPrompt(input, prompt) {
    prompt.hidden = false;
    input.setAttribute('aria-invalid', 'true');
    input.focus({ preventScroll: true });
  }

  function initialize(root) {
    root.querySelectorAll(FORM_SELECTOR).forEach((form) => {
      if (form.dataset[READY_KEY] === 'true') return;

      const input = form.querySelector('input[type="search"][name="q"]');
      const shell = form.closest('[data-sb-home-search-shell]');
      const prompt = shell && shell.querySelector('[data-sb-home-search-prompt]');
      if (!input || !prompt) return;

      updatePlaceholder(input);
      form.dataset[READY_KEY] = 'true';
      form.addEventListener('submit', (event) => {
        const query = input.value.trim();
        if (query) {
          hidePrompt(input, prompt);
          return;
        }

        event.preventDefault();
        showPrompt(input, prompt);
      });

      input.addEventListener('invalid', (event) => {
        event.preventDefault();
        showPrompt(input, prompt);
      });

      input.addEventListener('input', () => {
        if (input.value.trim()) hidePrompt(input, prompt);
      });
    });
  }

  function start() {
    addViewportChangeListener(reloadMotionVideos);
    addViewportChangeListener(updatePlaceholders);
    initialize(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  if (document.readyState === 'complete') {
    startMotionVideos(document);
  } else {
    window.addEventListener('load', () => startMotionVideos(document), { once: true });
  }

  document.addEventListener('shopify:section:load', (event) => {
    initialize(event.target);
    startMotionVideos(event.target);
  });
})();
